export const SERVER_URL = "http://localhost:5000";